import React from 'react';
import {Switch, Route} from 'react-router';
import {Question, Home, Detail, Profile} from "./containers/index";
import {useDispatch, useSelector} from "react-redux";
import {authentication} from "./modules/User/actions";
import {Loading} from "./components/Common";
import * as Common from "./components/Common/index";
import {updateUsersList} from "./modules/Users/actions";

const App = () => {
    const dispatch = useDispatch();
    const userState = useSelector(state => state.user);

    if (!userState.isLoggedIn) {
        dispatch(updateUsersList());
        dispatch(authentication())
    }

    return (
        <React.Fragment>
            <Common.HeadTags />
            <Common.Header />
            {(userState.isLoggedIn) ? (
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route path="/post" component={Question} />
                    <Route path="/detail/:id" component={Detail} />
                    <Route path="/profile" component={Profile} />
                </Switch>
            ) : (
                <Loading />
            )}
        </React.Fragment>
    )
};

export default App